import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { NotFoundComponent } from './modules/not-found/not-found.component';
import { AccessDeniedComponent } from './modules/access-denied/access-denied.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('../app/modules/dashboard/dashboard.module').then((a) => a.DashboardModule),
    canActivate: [AutoLoginPartialRoutesGuard],
  },
  {
    path: 'role',
    // canActivate: [UserGuard],
    loadChildren: () => import('../app/modules/role/role.module').then((a) => a.RoleModule),
    canActivate: [AutoLoginPartialRoutesGuard],
  },
  {
    path: 'table-category',
    // canActivate: [UserGuard],
    loadChildren: () =>
      import('../app/modules/table-catgoory/table-catgoory.module').then(
        (a) => a.TableCategoryModule,
      ),
    canActivate: [AutoLoginPartialRoutesGuard],
  },
  {
    path: 'user',
    // canActivate: [UserGuard],
    loadChildren: () => import('../app/modules/user/user.module').then((a) => a.UserModule),
    canActivate: [AutoLoginPartialRoutesGuard],
  },
  {
    path: 'database',
    // canActivate: [UserGuard],
    loadChildren: () =>
      import('../app/modules/database/database.module').then((a) => a.DatabaseModule),
    canActivate: [AutoLoginPartialRoutesGuard],
  },
  {
    path: 'table',
    // canActivate: [UserGuard],
    loadChildren: () => import('../app/modules/table/table.module').then((a) => a.TableModule),
    canActivate: [AutoLoginPartialRoutesGuard],
  },
  {
    path: 'table-group',
    // canActivate: [UserGuard],
    loadChildren: () =>
      import('../app/modules/table-group/table-group.module').then((a) => a.TableGroupModule),
    canActivate: [AutoLoginPartialRoutesGuard],
  },
  {
    path: 'my-reports',
    // canActivate: [UserGuard],
    loadChildren: () =>
      import('../app/modules/myreport/myreport.module').then((a) => a.MyreportModule),
    canActivate: [AutoLoginPartialRoutesGuard],
  },
  {
    path: 'dynamic',
    // canActivate: [UserGuard],
    loadChildren: () =>
      import('../app/modules/dynamic/dynamic.module').then((a) => a.DynamicModule),

    canActivate: [AutoLoginPartialRoutesGuard],
  },
  {
    path: 'dynamic-table/:id',
    redirectTo: 'dynamic/:id/table',
    pathMatch: 'full',
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
